import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SdvorItemCounterModule } from '@sdvor/product/ui';
import {
  InputComponent,
  ModalComponent,
  PersonalDataAgreeTextComponent,
  PhoneAuthorizedUserDirective,
  PhoneMaskFixDirective,
  SdvorButtonComponent,
  SdvorCheckboxComponent,
  SdvorSelectModule,
} from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { provideNgxMask } from 'ngx-mask';
import { BetonOrderFormComponent } from './beton-order-form.component';

@NgModule({
  declarations: [BetonOrderFormComponent],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    ModalComponent,
    ReactiveFormsModule,
    SdvorSelectModule,
    IconModule,
    SdvorButtonComponent,
    SdvorCheckboxComponent,
    PersonalDataAgreeTextComponent,
    InputComponent,
    SdvorItemCounterModule,
    PhoneMaskFixDirective,
    PhoneAuthorizedUserDirective,
  ],
  providers: [provideNgxMask()],
  exports: [BetonOrderFormComponent],
})
export class BetonOrderFormModule {}
